export const ITEMS_ON_CHAMELEON_PAGE = '20';
